import isEmpty from "lodash/isEmpty";
import { useTranslation } from "react-i18next";

import CuratedProperties from "~/components/organisms/CuratedProperties";
import CuratedPropertiesMobile from "~/components/organisms/CuratedPropertiesMobile";
import Section from "~/components/templates/SectionProject";
import { IProject } from "~/entities/project";

export interface SectionCuratedPropertiesProps {
  id: string;
  className?: string;
  title: string;
  projects: IProject[];
  handleOnSelectProject?: () => void;
}

const SectionCuratedProperties: React.FC<SectionCuratedPropertiesProps> = ({
  className = "",
  id,
  title,
  projects,
  handleOnSelectProject,
}) => {
  const { t } = useTranslation();

  if (isEmpty(projects)) return <></>;

  return (
    <Section data-name="SectionCuratedProperties" id={id} className={className}>
      <CuratedProperties
        title={t(title) || ""}
        projects={projects}
        handleOnSelectProject={handleOnSelectProject}
      />
      <CuratedPropertiesMobile
        title={t(title) || ""}
        projects={projects}
        handleOnSelectProject={handleOnSelectProject}
      />
    </Section>
  );
};

export default SectionCuratedProperties;
